// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__cz3vN","container_video":"styles_container_video__R+SsC","video":"styles_video__B8uCV","container_content":"styles_container_content__nGgvw"};